export interface VideoItem {
  id: string;
  title: string;
  typeKey: string;
  typeName: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  cover: string;
  description: string;
}

export interface BannerItem {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  tag: string;
}

export interface CategoryInfo {
  key: string;
  name: string;
  icon: string;
  description: string;
}

export const categoryList: CategoryInfo[] = [
  { key: "movie", name: "电影", icon: "ri-film-line", description: "精选院线大片与口碑经典，一网打尽" },
  { key: "tv", name: "电视剧", icon: "ri-tv-2-line", description: "热播连续剧与精品剧集，追剧不停" },
  { key: "variety", name: "综艺", icon: "ri-mic-line", description: "爆款综艺与真人秀，欢乐随时在线" },
  { key: "anime", name: "动漫", icon: "ri-ghost-2-line", description: "人气动画与新番连载，热血与治愈并存" },
  { key: "documentary", name: "纪录片", icon: "ri-earth-line", description: "探索自然与人文纪实，看见更大的世界" },
];

export const regionList: string[] = [
  "全部",
  "中国大陆",
  "美国",
  "韩国",
  "日本",
  "英国",
  "中国香港",
];

export const yearList: number[] = [2024, 2023, 2022, 2021, 2020];

export const sortList: { key: string; label: string }[] = [
  { key: "latest", label: "最新" },
  { key: "hot", label: "最热" },
  { key: "rating", label: "评分" },
];

export const bannerList: BannerItem[] = [
  {
    id: "1",
    title: "星际远征",
    subtitle: "穿越星海的史诗冒险，人类文明的最终远航",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20cinematic%20scene%20with%20deep%20orange%20and%20teal%20nebula%2C%20distant%20spaceship%20silhouette%2C%20dramatic%20atmospheric%20lighting%2C%20warm%20amber%20tones%20on%20dark%20background%2C%20highly%20detailed%20digital%20art%2C%20cinematic%20composition&width=1600&height=900&seq=vp-hero-01&orientation=landscape",
    tag: "院线热映",
  },
  {
    id: "5",
    title: "长安夜行",
    subtitle: "盛世长安的风云暗涌，一夜之间人心难测",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20at%20night%20with%20glowing%20lanterns%2C%20warm%20orange%20glow%20against%20deep%20blue%20sky%2C%20misty%20courtyard%2C%20cinematic%20atmospheric%20period%20drama%20scene%2C%20rich%20golden%20tones%2C%20highly%20detailed%20digital%20painting%2C%20wide%20composition&width=1600&height=900&seq=vp-hero-02&orientation=landscape",
    tag: "独播大剧",
  },
  {
    id: "9",
    title: "欢乐一家亲",
    subtitle: "明星家庭爆笑日常，治愈你的每一个夜晚",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20modern%20variety%20show%20stage%20with%20warm%20orange%20spotlights%2C%20playful%20neon%20accents%2C%20confetti%20and%20celebration%20atmosphere%2C%20energetic%20festive%20mood%2C%20highly%20detailed%20digital%20art%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=vp-hero-03&orientation=landscape",
    tag: "爆款综艺",
  },
  {
    id: "21",
    title: "蓝色星球志",
    subtitle: "深入深海与极地，记录地球上最壮丽的生命",
    image:
      "https://readdy.ai/api/search-image?query=Underwater%20deep%20ocean%20scene%20with%20rays%20of%20sunlight%2C%20teal%20water%20and%20warm%20orange%20coral%2C%20majestic%20documentary%20nature%20photography%2C%20cinematic%20atmospheric%20lighting%2C%20highly%20detailed%20digital%20art%2C%20wide%20panoramic%20composition&width=1600&height=900&seq=vp-hero-04&orientation=landscape",
    tag: "高分纪录",
  },
];

export const videoList: VideoItem[] = [
  {
    id: "1",
    title: "星际远征",
    typeKey: "movie",
    typeName: "电影",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险", "动作"],
    rating: 8.9,
    duration: "2小时28分",
    director: "克里斯托弗·诺兰",
    actors: ["李维·阿尔文", "艾米莉亚· 桑德斯", "张远"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20a%20lone%20astronaut%20before%20a%20giant%20glowing%20orange%20planet%2C%20deep%20space%20nebula%2C%20dramatic%20warm%20amber%20lighting%2C%20minimal%20elegant%20composition%2C%20highly%20detailed%20digital%20art%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-01&orientation=portrait",
    description:
      "人类文明濒临能源危机，一支由顶尖科学家组成的远征队踏上穿越星海的旅程，去寻找传说中的第二家园。旅途中，他们不仅要面对宇宙深处的未知威胁，也要直面人性与信念的考验。影片以宏大的视效与细腻的情感，讲述了一段关于勇气、牺牲与希望的史诗故事。",
  },
  {
    id: "2",
    title: "城市之光",
    typeKey: "movie",
    typeName: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "社会"],
    rating: 8.4,
    duration: "1小时52分",
    director: "陈可然",
    actors: ["王劲松", "刘亦菲", "周冬雨"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20movie%20poster%20with%20city%20skyline%20at%20dusk%20glowing%20orange%2C%20lonely%20figure%20on%20a%20bridge%2C%20soft%20golden%20hour%20light%2C%20cinematic%20minimal%20composition%2C%20highly%20detailed%20photographic%20style%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-02&orientation=portrait",
    description:
      "深夜的城市里，三个陌生人因一场意外而相遇。他们在各自的生活困境中挣扎，却因为彼此的善意而重新找到方向。影片用温柔的镜头语言，记录普通人在都市夹缝中相互照亮的故事。",
  },
  {
    id: "3",
    title: "深海救援",
    typeKey: "movie",
    typeName: "电影",
    year: 2024,
    region: "中国大陆",
    genres: ["动作", "灾难", "剧情"],
    rating: 8.1,
    duration: "2小时05分",
    director: "林浩然",
    actors: ["吴京", "张译", "章子怡"],
    cover:
      "https://readdy.ai/api/search-image?query=Tense%20disaster%20action%20movie%20poster%20with%20deep%20blue%20ocean%20and%20warm%20orange%20rescue%20lights%2C%20submarine%20silhouette%2C%20dramatic%20underwater%20atmosphere%2C%20cinematic%20high%20contrast%20composition%2C%20highly%20detailed%20digital%20art%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-03&orientation=portrait",
    description:
      "一场突如其来的海底事故让十二名工程师被困深海。面对不断下降的氧气与逼近的极限时间，救援队长带领团队展开与死神赛跑的营救行动，谱写了一曲关于责任与担当的英雄赞歌。",
  },
  {
    id: "4",
    title: "时光情书",
    typeKey: "movie",
    typeName: "电影",
    year: 2022,
    region: "中国大陆",
    genres: ["爱情", "文艺"],
    rating: 7.9,
    duration: "1小时46分",
    director: "许安安",
    actors: ["周迅", "易烊千玺", "文淇"],
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20literary%20movie%20poster%20with%20two%20hands%20holding%20an%20old%20letter%2C%20warm%20orange%20sunset%20backlight%2C%20soft%20bokeh%2C%20nostalgic%20cinematic%20mood%2C%20delicate%20minimal%20composition%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-04&orientation=portrait",
    description:
      "一封迟到了十年的情书，让两个早已走散的人在旧书店重逢。影片以细腻的笔触，讲述时光流转中未曾改变的心意，让人重新相信爱情最温柔的模样。",
  },
  {
    id: "5",
    title: "长安夜行",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "悬疑", "权谋"],
    rating: 9.0,
    duration: "全48集",
    director: "孔笙",
    actors: ["张若昀", "刘诗诗", "王阳"],
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20evocative%20costume%20drama%20poster%20with%20a%20scholar%20in%20dark%20robe%20before%20lantern-lit%20palace%20at%20night%2C%20warm%20orange%20glow%20on%20deep%20indigo%20background%2C%20mysterious%20cinematic%20mood%2C%20highly%20detailed%20digital%20painting%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-05&orientation=portrait",
    description:
      "大唐盛世的长安城内，一桩离奇命案牵出层层惊天的秘密。年轻的司刑官与神秘的女画师联手追查真相，却在权谋漩涡中逐渐发现，真正的敌人或许就藏在灯火最亮的地方。",
  },
  {
    id: "6",
    title: "都市迷航",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "都市"],
    rating: 8.6,
    duration: "全36集",
    director: "五百",
    actors: ["秦昊", "谭卓", "段奕宏"],
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20crime%20thriller%20poster%20with%20a%20lone%20figure%20in%20a%20narrow%20neon%20alley%2C%20warm%20orange%20street%20light%20against%20cold%20shadow%2C%20moody%20rain-soaked%20atmosphere%2C%20cinematic%20high%20contrast%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-06&orientation=portrait",
    description:
      "一名刑警在追查连环案件时，发现所有线索都指向自己尘封的过去。随着真相一层层揭开，正义与复仇的界限变得模糊，他必须在迷雾中做出抉择。",
  },
  {
    id: "7",
    title: "山海行记",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2024,
    region: "中国大陆",
    genres: ["奇幻", "冒险", "古装"],
    rating: 8.7,
    duration: "全40集",
    director: "林玉芬",
    actors: ["赵丽颖", "龚俊", "李沁"],
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20drama%20poster%20with%20a%20young%20traveler%20before%20mythical%20mountains%20and%20glowing%20clouds%2C%20warm%20orange%20and%20teal%20gradient%20sky%2C%20epic%20cinematic%20mood%2C%20highly%20detailed%20digital%20painting%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-07&orientation=portrait",
    description:
      "传说中失落的山海秘境重现人间，一位身负使命的少女与伙伴们踏上寻访之路。他们穿越奇幻异境，结识异族盟友，也在冒险中逐渐解开自身命运的谜团。",
  },
  {
    id: "8",
    title: "青春回声",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "校园", "成长"],
    rating: 8.0,
    duration: "全30集",
    director: "刘畅",
    actors: ["张子枫", "王俊凯", "沈月"],
    cover:
      "https://readdy.ai/api/search-image?query=Youth%20coming-of-age%20poster%20with%20high%20school%20students%20on%20a%20sunny%20track%20field%2C%20warm%20orange%20sunlight%20lens%20flare%2C%20nostalgic%20soft%20tone%2C%20fresh%20cinematic%20composition%2C%20highly%20detailed%20photographic%20style%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-08&orientation=portrait",
    description:
      "高三那年，五个性格迥异的少年因为一支乐队走到一起。他们在学业压力、梦想抉择与友情考验中跌跌撞撞地成长，用歌声记录下最珍贵的青春时光。",
  },
  {
    id: "9",
    title: "欢乐一家亲",
    typeKey: "variety",
    typeName: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "家庭", "搞笑"],
    rating: 8.5,
    duration: "更新至12期",
    director: "王征宇",
    actors: ["何炅", "谢娜", "黄磊"],
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20family%20variety%20show%20poster%20with%20colorful%20warm%20orange%20studio%20stage%2C%20playful%20props%2C%20confetti%2C%20joyful%20festive%20atmosphere%2C%20bright%20clean%20design%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-09&orientation=portrait",
    description:
      "六组明星家庭共同入住欢乐村，通过一周的相处与协作完成任务。节目以轻松幽默的方式展现亲情与友情的温暖，让观众在笑声中收获感动。",
  },
  {
    id: "10",
    title: "音乐巅峰夜",
    typeKey: "variety",
    typeName: "综艺",
    year: 2023,
    region: "中国大陆",
    genres: ["音乐", "竞演"],
    rating: 8.3,
    duration: "更新至10期",
    director: "洪涛",
    actors: ["李健", "周深", "邓紫棋"],
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20a%20singer%20in%20warm%20orange%20spotlight%20on%20dark%20stage%2C%20glowing%20light%20beams%2C%20passionate%20cinematic%20concert%20mood%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-10&orientation=portrait",
    description:
      "顶级歌手同台竞演，每一期都以全新编曲挑战经典与流行。舞台之上是实力的较量，舞台之下是音乐人对梦想最真诚的告白。",
  },
  {
    id: "11",
    title: "美食环游记",
    typeKey: "variety",
    typeName: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["美食", "旅行"],
    rating: 8.2,
    duration: "更新至8期",
    director: "陈晓卿",
    actors: ["蔡澜", "陈晓卿", "白鹿"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20food%20travel%20show%20poster%20with%20steaming%20local%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20orange%20lantern%20light%2C%20cozy%20street%20market%20ambience%2C%20appetizing%20detailed%20food%20photography%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-11&orientation=portrait",
    description:
      "主持人带着嘉宾走遍大江南北，寻访街头巷尾的地道风味。每一道美食背后，都是一段关于人情、乡愁与传承的温暖故事。",
  },
  {
    id: "12",
    title: "探索未知",
    typeKey: "documentary",
    typeName: "纪录片",
    year: 2023,
    region: "英国",
    genres: ["自然", "科普"],
    rating: 9.2,
    duration: "全8集",
    director: "阿拉斯泰尔·福瑟吉尔",
    actors: ["大卫·爱登堡"],
    cover:
      "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20majestic%20mountain%20range%20at%20sunrise%2C%20warm%20orange%20golden%20light%20over%20misty%20valleys%2C%20awe-inspiring%20cinematic%20landscape%2C%20highly%20detailed%20photographic%20style%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-12&orientation=portrait",
    description:
      "从极地冰原到热带雨林，从万米深海到雪山之巅，本片用震撼的影像记录地球上最不可思议的自然奇观，带领观众重新认识我们赖以生存的星球。",
  },
  {
    id: "13",
    title: "文明的回响",
    typeKey: "documentary",
    typeName: "纪录片",
    year: 2022,
    region: "中国大陆",
    genres: ["历史", "人文"],
    rating: 9.0,
    duration: "全10集",
    director: "金铁木",
    actors: ["解说：任志宏"],
    cover:
      "https://readdy.ai/api/search-image?query=History%20documentary%20poster%20with%20ancient%20Chinese%20bronze%20artifacts%20and%20scrolls%20on%20warm%20terracotta%20background%2C%20soft%20orange%20museum%20lighting%2C%20elegant%20civilization%20theme%2C%20highly%20detailed%20still%20life%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-13&orientation=portrait",
    description:
      "跨越五千年时光，本片走访数十处考古遗址与博物馆，用文物与遗迹串联起中华文明绵延不绝的精神脉络，讲述那些被时间尘封却从未远去的故事。",
  },
  {
    id: "14",
    title: "机械纪元",
    typeKey: "movie",
    typeName: "电影",
    year: 2023,
    region: "美国",
    genres: ["科幻", "动作"],
    rating: 8.2,
    duration: "2小时14分",
    director: "丹尼斯·维伦纽瓦",
    actors: ["瑞恩·高斯林", "赞达亚", "哈里森·福特"],
    cover:
      "https://readdy.ai/api/search-image?query=Dystopian%20sci-fi%20movie%20poster%20with%20a%20humanoid%20robot%20silhouette%20against%20a%20glowing%20orange%20city%2C%20cold%20teal%20shadows%2C%20futuristic%20cinematic%20mood%2C%20highly%20detailed%20digital%20art%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-14&orientation=portrait",
    description:
      "当人工智能觉醒，人类与机械的界限被彻底打破。一名追查失踪案的探员卷入一场关乎全人类未来的阴谋，在冰冷的科技世界中寻找仅存的人性温度。",
  },
  {
    id: "15",
    title: "风起云涌",
    typeKey: "movie",
    typeName: "电影",
    year: 2022,
    region: "中国大陆",
    genres: ["战争", "历史", "剧情"],
    rating: 8.3,
    duration: "2小时36分",
    director: "冯小刚",
    actors: ["张涵予", "段奕宏", "朱亚文"],
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20war%20drama%20movie%20poster%20with%20soldiers%20silhouette%20amid%20smoke%20and%20embers%2C%20warm%20orange%20firelight%20against%20dark%20sky%2C%20heroic%20cinematic%20mood%2C%20gritty%20highly%20detailed%20texture%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-15&orientation=portrait",
    description:
      "烽火连天的年代里，一群年轻人在家国与个人之间做出抉择。影片以真实历史为底色，刻画战火中普通人的坚韧与牺牲，令人热血又热泪。",
  },
  {
    id: "16",
    title: "星海拾贝",
    typeKey: "anime",
    typeName: "动漫",
    year: 2024,
    region: "日本",
    genres: ["动画", "奇幻", "治愈"],
    rating: 8.9,
    duration: "全24集",
    director: "新海诚",
    actors: ["配音：花泽香菜", "神木隆之介"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20with%20a%20girl%20standing%20on%20a%20shore%20under%20a%20vast%20starry%20orange-teal%20twilight%20sky%2C%20glowing%20stars%20and%20sea%20reflection%2C%20dreamy%20cinematic%20anime%20style%2C%20highly%20detailed%20illustration%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-16&orientation=portrait",
    description:
      "海边的少年在一次涨潮中拾到一枚会唱歌的贝壳，从此被卷入跨越星海的奇妙冒险。动画以唯美的画面讲述关于勇气、守护与成长的故事。",
  },
  {
    id: "17",
    title: "悬案追踪",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2024,
    region: "中国香港",
    genres: ["犯罪", "悬疑"],
    rating: 8.5,
    duration: "全28集",
    director: "杜琪峰",
    actors: ["古天乐", "张家辉", "刘青云"],
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20poster%20with%20a%20detective%20silhouette%20in%20a%20shadowy%20rainy%20city%2C%20warm%20orange%20streetlamp%20glow%20against%20cool%20dark%20tones%2C%20tension%20cinematic%20mood%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-17&orientation=portrait",
    description:
      "一桩跨越十五年的悬案重新浮出水面，退休警官与年轻搭档联手重启调查。随着线索逐渐清晰，当年的真相远比想象中更加令人唏嘘。",
  },
  {
    id: "18",
    title: "云端客栈",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2023,
    region: "中国大陆",
    genres: ["治愈", "生活", "文艺"],
    rating: 8.4,
    duration: "全26集",
    director: "傅东育",
    actors: ["刘亦菲", "李现", "姚晨"],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20healing%20drama%20poster%20with%20a%20mountain%20inn%20at%20golden%20sunset%2C%20warm%20orange%20light%20through%20windows%2C%20surrounded%20by%20misty%20forest%2C%20peaceful%20cinematic%20mood%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-18&orientation=portrait",
    description:
      "厌倦都市喧嚣的女主辞去工作，在雪山脚下开了一间小客栈。形形色色的旅客带来各自的故事，让这间小小的客栈成为治愈心灵的温暖港湾。",
  },
  {
    id: "19",
    title: "极限挑战队",
    typeKey: "variety",
    typeName: "综艺",
    year: 2023,
    region: "中国大陆",
    genres: ["竞技", "户外"],
    rating: 7.9,
    duration: "更新至14期",
    director: "严敏",
    actors: ["黄渤", "孙红雷", "王迅"],
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20variety%20show%20poster%20with%20contestants%20on%20a%20rugged%20mountain%20challenge%2C%20warm%20orange%20sunset%20light%2C%20energetic%20action%20atmosphere%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-19&orientation=portrait",
    description:
      "六位明星组成挑战队，深入荒野与城市完成一个个高难度任务。节目在紧张刺激的竞争中，展现团队协作与永不放弃的精神。",
  },
  {
    id: "20",
    title: "国风雅集",
    typeKey: "variety",
    typeName: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["文化", "音乐"],
    rating: 8.6,
    duration: "更新至9期",
    director: "陈同",
    actors: ["方锦龙", "自得琴社", "李玉刚"],
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20traditional%20culture%20show%20poster%20with%20classical%20instruments%20and%20silk%20scrolls%2C%20warm%20orange%20and%20ink%20tones%2C%20elegant%20refined%20atmosphere%2C%20highly%20detailed%20artistic%20composition%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-20&orientation=portrait",
    description:
      "当传统国乐遇上现代舞台，一场跨越时空的文化盛宴就此展开。节目邀请民乐大师与新锐音乐人合作，让古老旋律在当代焕发全新生命力。",
  },
  {
    id: "21",
    title: "蓝色星球志",
    typeKey: "documentary",
    typeName: "纪录片",
    year: 2024,
    region: "英国",
    genres: ["自然", "海洋"],
    rating: 9.4,
    duration: "全7集",
    director: "BBC 自然纪录团队",
    actors: ["解说：大卫·爱登堡"],
    cover:
      "https://readdy.ai/api/search-image?query=Ocean%20documentary%20poster%20with%20a%20whale%20gliding%20through%20deep%20teal%20water%20lit%20by%20warm%20orange%20sunlight%20rays%2C%20awe-inspiring%20underwater%20cinematic%20scene%2C%20highly%20detailed%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-21&orientation=portrait",
    description:
      "从温暖的珊瑚海到冰冷的深海沟壑，本片用前所未有的镜头语言，记录海洋生命的壮丽与脆弱，唤醒人们对蓝色星球的敬畏与守护之心。",
  },
  {
    id: "22",
    title: "岁月如歌",
    typeKey: "movie",
    typeName: "电影",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.7,
    duration: "1小时58分",
    director: "张艺谋",
    actors: ["巩俐", "张译", "马丽"],
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20family%20drama%20movie%20poster%20with%20an%20elderly%20couple%20on%20a%20rural%20road%20at%20warm%20orange%20sunset%2C%20soft%20golden%20light%2C%20tender%20emotional%20cinematic%20mood%2C%20highly%20detailed%20photographic%20style%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-22&orientation=portrait",
    description:
      "一对平凡夫妻用四十年光阴，见证了时代变迁与家庭冷暖。影片以质朴的叙事和真挚的情感，讲述普通人一生中最动人的守望与陪伴。",
  },
  {
    id: "23",
    title: "幻城奇缘",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2024,
    region: "中国大陆",
    genres: ["奇幻", "爱情", "古装"],
    rating: 8.1,
    duration: "全38集",
    director: "鞠觉亮",
    actors: ["杨幂", "罗云熙", "陈都灵"],
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20costume%20drama%20poster%20with%20a%20couple%20before%20a%20glowing%20magical%20city%2C%20warm%20orange%20and%20teal%20aurora%20sky%2C%20ethereal%20cinematic%20mood%2C%20highly%20detailed%20digital%20painting%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-23&orientation=portrait",
    description:
      "在漂浮于云端的幻城之中，一位凡人少女与神秘的城主相遇。为了守护彼此与这座城，他们携手对抗宿命，谱写一段跨越种族的浪漫传奇。",
  },
  {
    id: "24",
    title: "都市恋歌",
    typeKey: "tv",
    typeName: "电视剧",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "都市", "职场"],
    rating: 7.8,
    duration: "全32集",
    director: "李木戈",
    actors: ["杨紫", "肖战", "张新成"],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20with%20a%20couple%20on%20a%20city%20rooftop%20at%20dusk%2C%20warm%20orange%20skyline%20glow%2C%20tender%20cinematic%20mood%2C%20highly%20detailed%20photographic%20style%2C%20portrait%20orientation&width=600&height=900&seq=vp-poster-24&orientation=portrait",
    description:
      "两个在都市打拼的年轻人因工作结缘，从针锋相对的对手到彼此依靠的伴侣。剧集以真实细腻的笔触，讲述当代都市中关于梦想与爱情的双向奔赴。",
  },
];